import { useEffect, useRef, useState } from 'react';
import { register, call, remove } from '../../funcStore';
import { logAction } from '../../api/logApi';

const styles = {
  filterField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontSize: '0.85rem',
  },
  filterLabel: {
    color: '#555',
  },
  filterInput: {
    padding: '6px 8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
};

const STATE_BEFORE_INIT = 'beforeInit';
const STATE_CHANGING = 'changing';
const STATE_CHANGED = 'changed';

function FilterSelect({ groupKey, filterKey, label, options }) {
  const [state, setState] = useState(STATE_BEFORE_INIT);

  const stateRef = useRef(state);
  stateRef.current = state;

  const funcKeyRef = useRef(`filterSelect.${groupKey}.${filterKey}`);
  const funcKey = funcKeyRef.current;

  const dataRef = useRef({
    value: '',
  });

  const sync = () => {
    const groupFilters = call('searchPage.getFilter', groupKey);
    dataRef.current.value = (groupFilters && groupFilters[filterKey]) || '';
  };

  const notifyChanged = () => {
    setState(
      stateRef.current === STATE_CHANGED ? STATE_CHANGING : STATE_CHANGED
    );
  };

  const init = () => {
    sync();

    register(`${funcKey}.getState`, () => stateRef.current);

    register(`${funcKey}.getValue`, () => dataRef.current.value);

    register(`${funcKey}.change`, (value) => {
      dataRef.current.value = value;
      logAction('filter_change', { groupKey, filterKey, value });
      call('searchPage.setFilter', groupKey, filterKey, value);
      notifyChanged();
    });

    register(`${funcKey}.refresh`, () => {
      sync();
      notifyChanged();
    });

    setState(STATE_CHANGING);
  };

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
    if(state === STATE_CHANGING){
      setState(STATE_CHANGED)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    return () => {
      remove(`${funcKey}.getState`);
      remove(`${funcKey}.getValue`);
      remove(`${funcKey}.change`);
      remove(`${funcKey}.refresh`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  const handleChange = (e) => {
    call(`${funcKey}.change`, e.target.value);
  };

  return (
    <div style={styles.filterField}>
      <label style={styles.filterLabel} htmlFor={`filter-${filterKey}`}>
        {label}
      </label>
      <select
        id={`filter-${filterKey}`}
        style={styles.filterInput}
        value={dataRef.current.value}
        onChange={handleChange}
      >
        <option value="">指定なし</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default FilterSelect;
